import { CommonFunctions } from "./common-functions";
import { DatePipe } from "@angular/common";
//import { DATE } from "ngx-bootstrap/chronos/units/constants";
import { isDateValid } from "ngx-bootstrap/chronos";
//import { getDate, addDays } from '@progress/kendo-date-math';

export class DateFunctions {
    public static getDate(data: any): Date {
        let ret: Date = null;
        if (CommonFunctions.hasValue(data)) {
            ret = new Date(data);
        }
        return ret;
    }
    public static getUtcDate(data: any): Date {
        let ret: Date = null;
        if (CommonFunctions.hasValue(data)) {
            if (data instanceof Date) {
                return data;
            }

            if (typeof data === "string") {
                const trimmedDate = data.trim();
                const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(trimmedDate);
                return new Date(hasTimeZone ? trimmedDate : `${trimmedDate}Z`);
            }

            ret = new Date(data);
        }
        return ret;
    }
    public static addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }
    public static getDateNow(): Date {
        let dateNow: Date = new Date(Date.now());
        return dateNow;
    }
    public static isValidDate(d: any) : boolean {
        return !isNaN(d) && (d instanceof Date);
    }
    public static whatisMonday(date: Date = null) {
        //get this current saturday and then take back a couple days

        if (date === null) {
            date = new Date();
            date.setHours(0); 
            date.setMinutes(0);
            date.setSeconds(0);
        }
        var day = this.getLastWeekday(date, 1);
        var d = new Date(day);
        //d.setDate(d.getDate() - 7);
        return d; // new Date(d.toDateString());
    }
    public static whatisSaturday() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 7);
        return new Date(d.toDateString());
    }
    public static whatisYearHistory() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 365);
        return new Date(d.toDateString());
    }
    public static whatis3MonthHistory() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 90);
        return new Date(d.toDateString());
    }
    public static whatis6MonthHistory() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 120);
        return new Date(d.toDateString());
    }
    public static getDateBackNDays(lastDays: number = 0): Date {
        let date = this.getDateNow();
        date.setDate(date.getDate() - lastDays);
        return date;

    }
    public static getLastWeekday(date: Date, weekday: number) { // 0 = sunday, 1 = monday, ... , 6 = saturday
        var d = new Date(date);
        d.setDate(d.getDate() + weekday - d.getDay()); // move to last of given weekday
        return d;
    }
    public static formatDate_short(value: Date) :string  {
        let dp: DatePipe = new DatePipe('en-US');
        return dp.transform(value, 'short');
    }
    
    public static getDateTimeWithUTCOffset(date: Date) {
        let dateInp: Date = new Date(date);
        let retDate: Date = date;
        if (CommonFunctions.hasValue(date)) {
            //retDate = date.getUTCDate();
            var tzOff = dateInp.getTimezoneOffset();
            retDate = new Date(dateInp.getFullYear(), dateInp.getMonth(), dateInp.getDate(), dateInp.getHours() - (tzOff / 60), dateInp.getMinutes() - (tzOff % 60), dateInp.getSeconds());
        }
        return retDate;
    }

    public static getDateOnly(date: Date) {
        let dateInp: Date = new Date(date);
        let retDate: Date = dateInp;
        if (CommonFunctions.hasValue(dateInp)) {
            //retDate = date.getUTCDate();
            var tzOff = dateInp.getTimezoneOffset();
            retDate = new Date(dateInp.getFullYear(), dateInp.getMonth(), dateInp.getDate());
        }
        return retDate;
    }
    public static getDateWithUTCOffset(date: Date) {
        let dateInp: Date = new Date(date);
        let retDate: Date = date;
        if (CommonFunctions.hasValue(date)) {
            //retDate = date.getUTCDate();
            var tzOff = dateInp.getTimezoneOffset();
            retDate = new Date(dateInp.getFullYear(), dateInp.getMonth(), dateInp.getDate(), 0 - (tzOff / 60), 0, 0);
        }
        return retDate;
    }
    public static earliestReasonableYear: number = 1970;
    public static hasReasonableDateValue(date: any) : boolean {
        let hasValue: boolean = false;
        try {
            let dateInp: Date = new Date(date);

            if (isDateValid(dateInp)) {
                if (dateInp.getFullYear() >= DateFunctions.earliestReasonableYear) {
                    hasValue = true;
                }
            }
        }
        catch (err) {

        }
        return hasValue;

    }
    //public static getDateTimeWithUTCOffset(date: Date) {
    //    let retDate: Date = date;
    //    if (this.isValidDate(date)) {
    //        let dateInp: Date = new Date(date);
    //        retDate = dateInp;
    //        if (CommonFunctions.hasValue(dateInp)) {
    //            var tzOff = dateInp.getTimezoneOffset();
    //            retDate = new Date(dateInp.getFullYear(), dateInp.getMonth(), dateInp.getDate(), dateInp.getHours() - (tzOff / 60), dateInp.getMinutes(), dateInp.getSeconds());
    //        }
    //    }
    //    return retDate;
    //}
    //public static getDateWithUTCOffset(date: Date) {
    //    let retDate: Date = date;
    //    if (this.isValidDate(date)) {
    //        let dateInp: Date = new Date(date);
    //        retDate = dateInp;
    //        if (CommonFunctions.hasValue(dateInp)) {
    //            var tzOff = dateInp.getTimezoneOffset();
    //            retDate = new Date(dateInp.getFullYear(), dateInp.getMonth(), dateInp.getDate(), 0 - (tzOff / 60), 0, 0);
    //        }
    //    }
    //    return retDate;
    //}
    public static getDateTimeNowWithUTCOffset() {
        let date: Date = this.getDateNow();
        return this.getDateTimeWithUTCOffset(date);
    }
    public static getDateNowWithUTCOffset() {
        let date: Date = this.getDateNow();
        return this.getDateWithUTCOffset(date);
    }
    public static getDateDiffFormatted(dateStart: Date, dateEnd: Date) {
        var seconds = Math.floor(((dateEnd.getTime()) - (dateStart.getTime())) / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);
        hours = hours;
        minutes = minutes - (days * 24 * 60) - (hours * 60);
        seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);
        return  String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0');
    }
    public static dateDiffHours(dateFirst: any, dateSecond: any = null): number {

        if (!this.isValidDate(dateFirst)) {
            return 0;
        }
        const dateSecondTemp = dateSecond == null ? this.getDateNow() : dateSecond;
        const diffInMs = Date.parse(dateSecondTemp) - Date.parse(dateFirst);
        const diffInHours = diffInMs / 1000 / 60 / 60;

        return diffInHours;
    }

    public static getISOStringWithoutMilliseconds(date: any): Date {
        let dateObject: Date = new Date(date);
        let isoStringWithoutMilliseconds: string = dateObject.toISOString().slice(0, -5);
        return new Date(isoStringWithoutMilliseconds);
    }
}
